module.exports = __webpack_public_path__ + "img/1568963970.cb7bbc67.jpg";